import styled from 'styled-components';
import { CssFuncs } from '../../../foundation/css/css.funcs';
import { Color } from '../color/color';

const Container = styled.div.withConfig({
  componentId: 'menu_container',
  displayName: 'Menu.Container',
})`
  border: 1px solid ${Color.black5};
  background: ${Color.black2};

  padding: 4px;
  border-radius: 8px;

  width: 240px;
`;

const Separator = styled.div.withConfig({
  componentId: 'menu_separator',
  displayName: 'Menu.Separator',
})`
  height: 1px;
  ${CssFuncs.css.margin({ y: '4px', x: '4px' })}
  background: ${Color.black5};
`;

export const MenuStyle = {
  Container,
  Separator,
};
